import type { Email, PaginatedApiResponse } from 'types';
import { baseQuery } from '../baseQuery';

export const getMessages = async (
  resourceType: 'customer' | 'job',
  messageType: 'emails' | 'sms',
  resourceId: string,
  { page = 1, recordsPerPage = 5 }: { page: number; recordsPerPage: number } = { page: 1, recordsPerPage: 5 },
) => {
  const paginationParams = new URLSearchParams({ page, per_page: recordsPerPage } as any);

  const data: PaginatedApiResponse<Email[]> = await baseQuery(
    `${resourceType}s/${resourceId}/${messageType}?${paginationParams.toString()}`,
  );

  return data;
};
